import { array } from 'fp-ts';
import { createAction } from '@mews/framework/redux';
import { DistributorPromiseThunkAction } from '../../../types';
import {
    FETCH_EXCHANGE_RATES_FAILED,
    FETCH_EXCHANGE_RATES_STARTED,
    FETCH_EXCHANGE_RATES_SUCCEEDED,
} from './actionTypes';
import { getFailedExchangeRates, hasExchangeRates } from './selectors';

interface FetchExchangeRatesOptions {
    enterpriseId: string;
    sourceCurrencyCode: string;
}

export const fetchExchangeRates =
    ({ enterpriseId, sourceCurrencyCode }: FetchExchangeRatesOptions): DistributorPromiseThunkAction =>
    async (dispatch, _getState, { apiService }) => {
        dispatch(createAction(FETCH_EXCHANGE_RATES_STARTED, { enterpriseId, sourceCurrencyCode }));
        return apiService
            .getExchangeRates({ enterpriseId, sourceCurrencyCode })
            .then((response) => {
                const exchangeRates = {
                    sourceCurrencyCode,
                    enterpriseId,
                    ...response,
                };

                dispatch(createAction(FETCH_EXCHANGE_RATES_SUCCEEDED, exchangeRates));
                return exchangeRates;
            })
            .catch((error) => {
                dispatch(createAction(FETCH_EXCHANGE_RATES_FAILED, { error, enterpriseId, sourceCurrencyCode }));
                throw error;
            });
    };

export const fetchFailedExchangeRates = (): DistributorPromiseThunkAction => async (dispatch, getState) => {
    const failedExchangeRates = getFailedExchangeRates(getState());

    if (array.size(failedExchangeRates) === 0) {
        return;
    }

    const promises = failedExchangeRates.map(async ({ enterpriseId, sourceCurrencyCode }) =>
        dispatch(fetchExchangeRates({ enterpriseId, sourceCurrencyCode }))
    );

    await Promise.all(promises);
};

export const fetchExchangeRatesWithCheck =
    ({ enterpriseId, sourceCurrencyCode }: FetchExchangeRatesOptions): DistributorPromiseThunkAction =>
    async (dispatch, getState) => {
        const state = getState();

        const hasPropertyExchangeRates = hasExchangeRates(state, { enterpriseId, currencyCode: sourceCurrencyCode });
        if (!hasPropertyExchangeRates) {
            await dispatch(fetchExchangeRates({ enterpriseId, sourceCurrencyCode }));
        }
    };
